import React from 'react';
import PropTypes from 'prop-types';
const CustomOptionComponent = ({ rowData, customClick, showChildren }) => {
  const viewClick = () => {
    customClick(rowData);
  };
  const toggleChildren = () => {
    customClick(rowData, 'SHOW_CHILDREN', !showChildren);
  };

  const fromLabel = rowData.fromAccountName;
  const dateLabel = rowData.createdDate;

  const renderChildOption = () => {
    return (
      <button
        className="c-btn c-btn--link"
        onClick={viewClick}
        aria-label={`View Payment Details, ${fromLabel}, ${dateLabel}`}
      >
        View
      </button>
    );
  };
  const renderParentOption = () => {
    return (
      <button className="c-btn c-btn--link" onClick={toggleChildren}>
        {showChildren ? 'Hide all' : 'Show all'}
      </button>
    );
  };
  return rowData.hasOwnProperty('children')
    ? renderParentOption()
    : renderChildOption();
};

CustomOptionComponent.propTypes = {
  rowData: PropTypes.object,
  customClick: PropTypes.func,
  showChildren: PropTypes.func.isRequired,
};

export default CustomOptionComponent;
